<template>
  <component :is="tag" class="title">
    <span class="prompt">&gt; </span>
    <span class="name">{{ props.text }}</span>
    <span class="cursor">_</span>
  </component>
</template>
<script lang="ts" setup>
import { defineProps } from 'vue';

const props = defineProps<{
  text: string
  tag?: string
}>();

const tag = props.tag || 'h1';
</script>

<style scoped>

.title {
  font-weight: 700;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Fira Code', 'Droid Sans Mono', monospace;
}

.title:where(h1) {
  font-size: clamp(2rem, 5vw, 4rem);
}

.title:where(h2) {
  font-size: 2.5rem;
}

@media (max-width: 768px) {
  .title:where(h2) {
    font-size: 2rem;
  }
}

.prompt {
  color: #00d1b2;
  margin-right: 0.5rem;
}

.name {
  background: linear-gradient(135deg, #00d1b2 0%, #3273dc 50%, #00d1b2 100%);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: gradient-shift 3s ease-in-out infinite;
}

.cursor {
  color: #00d1b2;
  animation: blink 1.2s infinite;
  font-weight: 400;
}

.description p {
  margin-bottom: 1rem;
}

.description p:last-child {
  margin-bottom: 0;
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}

@keyframes gradient-shift {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

@media (max-width: 768px) {

}
</style>
